class CustomizedFilter extends HTMLElement {
    constructor() {
      super();
      this.filterOption = $('.boost-pfs-container-default.boost-pfs-filter-style-2 .boost-pfs-filter-option .boost-pfs-filter-option-title');
      this.buttons = document.querySelectorAll('button.facets__display--apply-button');
      this.buttonMobile= document.querySelectorAll('button.facets__display--apply-button--mobile');
      this.listMenuItems = document.querySelectorAll('li.facets__item:not(.facets__item--disabled)');

      this.listMenuItemsMobile = document.querySelectorAll('li.mobile-facets__item:not(.mobile-facets__item--disabled)');
      this.priceButton = document.querySelectorAll('.facets__display--apply-button');

      this.selectItems();
      this.closeMobileMenu();
      this.applyButton();
      
    }


    applyButton(){
      const outterThis = this;

      [...this.buttons, ...this.buttonMobile, ...this.priceButton].forEach(function (item) {
      
        item.addEventListener('click', function (event) {
        
          event.preventDefault();
          const selectedItems = Array.from(outterThis.listMenuItems).filter(button => button.classList.contains('selected'));
          const selectedMobileItems = Array.from(outterThis.listMenuItemsMobile).filter(button => button.classList.contains('selected')); 
          let fullUrl = [];
          if (item.classList.contains("facets__display--apply-button-price")) {
            const priceRange = document.querySelector('price-range.facets__price');
            priceRange.querySelectorAll('input.field__input').forEach(function (el, index) {
              const localUrl = outterThis.appendLocalSearchURL(el, index, fullUrl, 'name', 'min');
              fullUrl.push(localUrl);
            })
          }
          else {
            [...selectedItems, ...selectedMobileItems].forEach(function (el, index) {
              const localUrl = outterThis.appendLocalSearchURL(el, index , fullUrl, 'param-name', 'param-value');
              fullUrl.push(localUrl);
            })
          }

          fullUrl = fullUrl.join('&');
          const urlWithFilters = window.location.origin + window.location.pathname + fullUrl;
          location.href = urlWithFilters;

        })
      })
    }

    appendLocalSearchURL(item, index, fullUrl, label, value) {
      let localUrl = [];
      if (index == 0 && fullUrl[0] === undefined) localUrl.push('?');
      localUrl.push(item.getAttribute(label));
      localUrl.push('=')
      if (item.tagName === 'INPUT' && item.value !== "") {
        localUrl.push(item.value);
      }
      else {
        if ((item.getAttribute(value)).includes('+')) localUrl.push(item.getAttribute(value).replaceAll('+', '%2B')) ;
        else localUrl.push(item.getAttribute(value));
      }

      return localUrl = localUrl.join('');
    }

    closeMobileMenu(){
      document.querySelector('.close__icon')?.addEventListener('click', function () {
        document.querySelector('.mobile-facets__disclosure').removeAttribute('open');
      })
    }

    selectItems(){



      [...this.listMenuItems, ...this.listMenuItemsMobile].forEach(function (item) {

        item.addEventListener('click', function (event) {
            item.classList.toggle('selected');
            event.stopImmediatePropagation();
        } );
        
      })
    }

}

customElements.define('boost-pfs-container-default.boost-pfs-filter-style-2', CustomizedFilter);

const boostFilter = new CustomizedFilter;